import { ImageUploader as LibImageUploader } from "@rothoblaas/design-system";
import { ReactNode, useEffect, useRef, useState } from "react";
import useI18n from "../../hooks/useTranslations";

interface useImageUploaderProps {
  defaultImage?: string;
  isLoading: boolean;
  disabled?: boolean;
  footer?: ReactNode;
}

const useImageUploader = ({ defaultImage, isLoading, disabled, footer }: useImageUploaderProps) => {
  const i18n = useI18n();

  const [newPicture, setNewPicture] = useState<File>();
  const [removePicture, setRemovePicture] = useState(false);

  const imageTimeStamp = useRef(new Date().getTime());

  useEffect(() => {
    setNewPicture(undefined);
    setRemovePicture(false);
  }, [defaultImage]);

  const currentImageUrl = defaultImage
    ? `${import.meta.env.VITE_BUCKET_URL}${defaultImage}?t=${imageTimeStamp.current}`
    : undefined;

  return {
    component: (
      <LibImageUploader
        currentImageUrl={currentImageUrl}
        isLoading={isLoading}
        disabled={disabled}
        footer={footer}
        placeholder={i18n.translation.common.dragAndDropOrUploadAnImage}
        dropLabel={i18n.translation.common.dropIt}
        rejectedLabel={i18n.translation.common.onlyImagesAreAllowed}
        removeLabel={i18n.translation.common.removeImage}
        resetLabel={i18n.translation.common.resetToDefault}
        onChange={(file, isRemoved) => {
          setNewPicture(file ?? undefined);
          setRemovePicture(isRemoved);
        }}
      />
    ),
    newImage: newPicture,
    removeImage: removePicture,
    onSave: () => {
      imageTimeStamp.current = new Date().getTime();
    },
  };
};

export default useImageUploader;
